import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class DocumentColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'LookupEditor/Templates/Columns/Document';
    }
}
